import DialogComponent from 'shared/ui/components/modals/DialogComponent.vue';

// 5 minutes
const RSVP_CACHE_TTL = 1000 * 60 * 5;

export default {
    data() {
        return {
            // timeOrigin assures we show this one per each tab
            // and after destroy, we continue showing the rsvp once per each edit/create view.
            cacheKey: `_CURRENT_USER__WARNED_ABOUT_PROBLEM_RSVP_AND_EMAIL_PROVIDERS__${performance.timeOrigin}`,
        };
    },

    destroyed() {
        this.$services.storage.remove(this.cacheKey, 'true');
    },

    methods: {
        warnUserAboutRSVPChange() {
            const messageShown = Boolean(this.$services.storage.get(this.cacheKey));

            if (!messageShown) {
                this.$services.storage.set(this.cacheKey, 'true', RSVP_CACHE_TTL);
                this.showWarning();
            }
        },

        showWarning() {
            this.$modal.show(DialogComponent, {
                title: this.$t('meetings.messages.rsvp_providers_sync_warning_title'),
                text: this.$i18n.t('meetings.messages.rsvp_providers_sync_warning'),
                buttons: [
                    {
                        title: this.$i18n.t('base.ok'),
                        handler: () => this.$modal.hide('rsv-change-waring-modal'),
                        class: 'btn btn-primary'
                    },
                ]
            }, {
                name: 'rsv-change-waring-modal',
                height: 'auto',
            });
        },
    },
};
